import { type ReactNode, createContext, useContext, useState } from 'react'

import BeatLoader from 'react-spinners/BeatLoader'
import styled from 'styled-components'


const defaultValues = {
    globalLoading: true,
    handleGlobalLoading: (_value: boolean) => {}
}

export const LoadingContext = createContext<typeof defaultValues>(defaultValues)

export const LoadingProvider = ({ children }: { children: ReactNode }) => {
    const [globalLoading, setGlobalLoading] = useState(true)
    const handleGlobalLoading = (value: boolean) => {
        setGlobalLoading(value)
    }
    return (
        <LoadingContext.Provider
            value={{
                globalLoading,
                handleGlobalLoading
            }}
        >
            {globalLoading && (
                <GlobalLoader>
                    <BeatLoader size={10}/>
                </GlobalLoader>
            )}

            {children}
        </LoadingContext.Provider>
    )
}

const GlobalLoader = styled.div`
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;

    display: flex;
    justify-content: center;
    align-items: center;
    background: rgba(255, 255, 255, 0.6);
`

export const useLoadingContext = () => useContext(LoadingContext)
